module.exports = __webpack_public_path__ + "img/dgjg2250_1.cf2bfae4.svg";